import React from 'react';
import { useTranslation } from 'react-i18next';

import MonthlyPaymentCta from 'components/Srp/MonthlyPaymentCalculator/MonthlyPaymentCta';
import { colors, screen } from 'components/styles/variables';
import useMonthlyPayment from 'lib/hooks/useMonthlyPayment';

import { formatPrice } from './utils';

export interface PriceProps {
  price: number;
  onClickMonthlyPaymentCalculator: () => void;
}

export default function Price(props: PriceProps): JSX.Element {
  const { price, onClickMonthlyPaymentCalculator } = props;

  const { t } = useTranslation();
  const monthlyPayment = useMonthlyPayment(price);

  function onClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void {
    onClickMonthlyPaymentCalculator();
    e.stopPropagation();
    e.preventDefault();
  }

  return (
    <div>
      {!price && <div className="no-price">{t('srp.noPrice')}</div>}

      {!!price && (
        <>
          <div className="price">{formatPrice(price)}</div>

          <MonthlyPaymentCta value={monthlyPayment} onClick={onClick} />
        </>
      )}

      <style jsx>{`
        .price {
          font-weight: bold;
          font-size: 20px;
          line-height: 26px;
          text-align: right;
          letter-spacing: 0.2px;
          padding-bottom: 2px;
        }

        .no-price {
          font-size: 18px;
          font-weight: 700;
          line-height: 22px;
          text-align: right;
          color: ${colors.G3};
          width: 116px;
          margin-top: 3px;
        }

        @media (max-width: ${screen.xsMax}) {
          .no-price {
            font-size: 16px;
            line-height: 20px;
            width: 103px;
          }
        }
      `}</style>
    </div>
  );
}
